import CryptoJS from "crypto-js";

const SECRET_KEY = "7fKq9XzVb0Yc6JDlm48eTAWnZrQ5uhEp";

export function encryptData(data: any) {
  try {
    const dataString = typeof data === "string" ? data : JSON.stringify(data);
    return CryptoJS.AES.encrypt(dataString, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
}

export function decryptData(encryptedData: any) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
}


export function generateFernetKey(){
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  const binaryString = String.fromCharCode.apply(null, Array.from(array));
  return btoa(binaryString)
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
}
